module.exports = __webpack_public_path__ + "img/IMG_9321_L_Wood_MockedUp.7bc616c0.jpg";